import { Component } from '@angular/core';
import {
  OrganizationSpaceCreateModalComponent
} from '@app/features/main/views/organization-spaces/modals/organization-space-create-modal/organization-space-create-modal.component';

@Component({
    templateUrl: './space-create-modal.component.html',
    standalone: false
})
export class SpaceCreateModalComponent extends OrganizationSpaceCreateModalComponent {
}
